import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useMutation } from '@tanstack/react-query';
import { authExtensionApiRef } from '@agilelab/plugin-wb-auth-extension-common';

export const useInvalidateUserTokens = () => {
  const authExtensionApi = useApi(authExtensionApiRef);
  const identityApi = useApi(identityApiRef);

  return useMutation({
    mutationFn: async (params: { userRef: string }) => {
      return authExtensionApi.invalidateUserTokens(
        { userRef: params.userRef },
        await identityApi.getCredentials(),
      );
    },
  });
};
